import { isDiscountAppliedToPayor } from 'Data/payment-plan.js'

export function getPayorDiscounts(payor, discounts) {
  return discounts.filter(discount => isDiscountAppliedToPayor(payor, discount))
}
